module.exports = __webpack_public_path__ + "33ebe5d747ffa1929178fa2216630935.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-14.png
// module id = 3138
// module chunks = 0